// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.caret-count[data-v-9f20781c] {\n    position: absolute;\n    width: 26px;\n    height: 26px;\n    top: 7px;\n    right: 10px;\n    border: 2px solid #50ae55;\n    border-radius: 50%;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
